import React from 'react';

const Alert = ({ messages }) => {
  if (!messages || !messages.length) {
    return null;
  }

  return (
    <div className='border border-solid border-[#11a7d8] p-5 rounded-lg text-[#11a7d8] bg-[#e6f4ff]'>
      {
        messages.map((message, index) => (
          <p
            key={`message_${index}`}
            className={`font-bold ${index === messages.length - 1 ? 'm-0' : ''}`}
          >
            {message}
          </p>
        ))
      }
    </div>
  )
};

export default Alert;



// WEBPACK FOOTER //
// src/components/Common/Alert/index.jsx